import { SailBoatSinkIcon } from './SailBoatSinkIcon';

/**
 * author: Michael Irigoyen
 * id BEF26F95-E584-4585-BBD7-3766740FBEBD
 * name sail-boat-sink
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sail-boat-sink.svg
 * tags
 * - Transportation + Water 
 */
export const SailBoatWreckIcon = SailBoatSinkIcon;
export default SailBoatWreckIcon